//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameStatus } from '../wheel.entity';

export const BetType = {
  INVENTORY: 'INVENTORY',
  BALANCE: 'BALANCE'
};

export default {
  name: 'WheelHomeBetCreator',
  props: {
    // 对应 wheelState.game()[cite: 38, 40]
    game: {
      type: Object,
      default: null
    },
    // 用户当前已注数列表，对应 wheelState.userBets()[cite: 40]
    userBets: {
      type: Array,
      default: () => []
    },
    // 当前选择的倍率颜色，对应 wheelState.betColor()[cite: 40]
    betColor: {
      type: [String,Number],
      default: ''
    },
    // 用户登录状态[cite: 40]
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    // 下注类型 (INVENTORY 或 BALANCE)[cite: 40]
    betType: {
      type: String,
      default: BetType.BALANCE
    },
    // 余额下注金额[cite: 40]
    betAmountUsd: {
      type: Number,
      default: 0
    },
    // 选中的饰品项[cite: 38]
    selectedInvItems: {
      type: Array,
      default: () => []
    },
    // 选中的饰品总价值[cite: 38, 40]
    selectedInventoryAmountUsd: {
      type: Number,
      default: 0
    },
    // 选中的饰品 ID 列表[cite: 40]
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      GameStatus,
      BetType,
      isCreatingBet: false,
      MIN_BET_AMOUNT_USD: 0.25
    };
  },
  computed: {
    selectedAmountUsd() {
      return this.betType === BetType.INVENTORY
        ? this.selectedInventoryAmountUsd
        : this.betAmountUsd;
    },
    isButtonDisabled() {
      if (!this.game) {
        return true;
      }

      return (
        this.game.status === GameStatus.STARTED ||
        this.game.status === GameStatus.ENDED ||
        this.selectedAmountUsd <= 0 ||
        this.userBets.length >= 20
      );
    }
  },
  methods: {
    formatCurrency(val) {
      if (val === undefined || val === null) return '$0.00';
      return `$${Number(val).toFixed(2)}`;
    },
    createBet() {
      if (!this.isAuthenticated) {
        this.$emit('open-login');
        return;
      }

      if (this.betType === BetType.INVENTORY && this.selectedAmountUsd < this.MIN_BET_AMOUNT_USD) {
        // 俄文翻译: Сумма ставки ниже минимальной. Минимально сумма ставки: 0.25 Coin -> 下注金额低于最小值。最低下注金额为：0.25 Coin
        this.$emit('notify-error', '下注金额低于最小值。最低下注金额为：0.25 Coin');
        return;
      }

      if (this.betType === BetType.BALANCE && this.betAmountUsd < this.MIN_BET_AMOUNT_USD) {
        this.$emit('notify-error', '下注金额低于最小值。最低下注金额为：0.25 Coin');
        return;
      }

      let inventoryItems = [];
      let betAmountUsd = 0;

      if (this.betType === BetType.BALANCE) {
        betAmountUsd = this.betAmountUsd;
      } else {
        inventoryItems = this.selectedIds;
      }

      this.isCreatingBet = true;

      // 向父级触发提交事件[cite: 40]
      this.$emit(
        'submit-bet',
        {
          color: this.betColor,
          type: this.betType,
          amount: betAmountUsd,
          items: inventoryItems
        },
        () => {
          this.isCreatingBet = false;
        }
      );
    }
  }
};
